// GST State Code master (Indian GSTIN state codes). Used for e-Way bill / e-Invoice
// state codes, which are preferred over deriving the code from the GSTIN prefix.

export const GST_STATES = [
    { code: "01", name: "Jammu & Kashmir" },
    { code: "02", name: "Himachal Pradesh" },
    { code: "03", name: "Punjab" },
    { code: "04", name: "Chandigarh" },
    { code: "05", name: "Uttarakhand" },
    { code: "06", name: "Haryana" },
    { code: "07", name: "Delhi" },
    { code: "08", name: "Rajasthan" },
    { code: "09", name: "Uttar Pradesh" },
    { code: "10", name: "Bihar" },
    { code: "11", name: "Sikkim" },
    { code: "12", name: "Arunachal Pradesh" },
    { code: "13", name: "Nagaland" },
    { code: "14", name: "Manipur" },
    { code: "15", name: "Mizoram" },
    { code: "16", name: "Tripura" },
    { code: "17", name: "Meghalaya" },
    { code: "18", name: "Assam" },
    { code: "19", name: "West Bengal" },
    { code: "20", name: "Jharkhand" },
    { code: "21", name: "Odisha" },
    { code: "22", name: "Chhattisgarh" },
    { code: "23", name: "Madhya Pradesh" },
    { code: "24", name: "Gujarat" },
    { code: "26", name: "Dadra & Nagar Haveli and Daman & Diu" },
    { code: "27", name: "Maharashtra" },
    { code: "29", name: "Karnataka" },
    { code: "30", name: "Goa" },
    { code: "31", name: "Lakshadweep" },
    { code: "32", name: "Kerala" },
    { code: "33", name: "Tamil Nadu" },
    { code: "34", name: "Puducherry" },
    { code: "35", name: "Andaman & Nicobar Islands" },
    { code: "36", name: "Telangana" },
    { code: "37", name: "Andhra Pradesh" },
    { code: "38", name: "Ladakh" },
    { code: "97", name: "Other Territory" },
    { code: "99", name: "Other Country" },
];

// Fast lookup: code -> name
const STATE_MAP = GST_STATES.reduce((acc, s) => {
    acc[s.code] = s.name;
    return acc;
}, {});

/**
 * Get the state name for a 2-digit GST state code.
 * @param {string|number} code - e.g. "29"
 * @returns {string} state name, or the code itself if unknown, or "" if empty
 */
export function getStateName(code) {
    if (code === null || code === undefined || code === "") return "";
    const key = String(code).padStart(2, "0");
    return STATE_MAP[key] || String(code);
}

/**
 * "29 - Karnataka" style label for a code (empty string when code is blank).
 */
export function getStateLabel(code) {
    const name = getStateName(code);
    if (!name) return "";
    return `${String(code).padStart(2, "0")} - ${name}`;
}
